const getFontAssetsDomain = () => {
  if (!window.ASSETS_DOMAIN) {
    return 'https://static.oneflow.com';
  }

  return window.ASSETS_DOMAIN;
};

export default getFontAssetsDomain;
